/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

import { EMPTY_FILTER_QUERY } from "./consts";

import type { PayloadAction } from "@reduxjs/toolkit";
import type { FilterQueryType } from "./types";

const name = "paymentActivity";

// TODO: fix types
type PaymentActivityState = {
  byId: Record<string, any>;
  list: string[]; // all IDs in display order
  pageMap: Record<string, string[]>; // page number: array of IDs
  next: string | null;
  selected: any; // todo: replace with specific type
  total: number;
  filters: FilterQueryType & {
    calendar_key?: string;
  };
};

const initialState: PaymentActivityState = {
  byId: {},
  list: [],
  pageMap: {},
  selected: null,
  next: null,
  total: 0,
  filters: EMPTY_FILTER_QUERY,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    upsertPage: (
      state,
      action: PayloadAction<{
        pageNumber: number;
        results: any;
        total: number;
      }>,
    ) => {
      const { results, total, pageNumber } = action.payload;

      results.forEach((activity: API.PaymentActivity) => {
        state.byId[activity.object_uuid] = activity;
      });

      state.pageMap[pageNumber] = results.map(
        (activity: API.PaymentActivity) => activity.object_uuid,
      );
      state.total = total;
    },

    appendResults: (
      state,
      action: PayloadAction<{
        results: API.PaymentActivity[];
        total: number;
      }>,
    ) => {
      const { results, total } = action.payload;

      const existingIds = new Set(state.list);
      results.forEach((activity: API.PaymentActivity) => {
        state.byId[activity.object_uuid] = activity;
        if (!existingIds.has(activity.object_uuid)) {
          state.list.push(activity.object_uuid);
          existingIds.add(activity.object_uuid);
        }
      });
      state.total = total;
    },

    replaceResults: (
      state,
      action: PayloadAction<{
        results: API.PaymentActivity[];
        total: number;
      }>,
    ) => {
      const { results, total } = action.payload;
      const uniqueIds = new Set<string>();

      results.forEach((activity: API.PaymentActivity) => {
        state.byId[activity.object_uuid] = activity;
        uniqueIds.add(activity.object_uuid);
      });
      state.list = Array.from(uniqueIds);
      state.total = total;
    },

    updateSelected: (state, action: PayloadAction<any>) => {
      const { payload } = action;
      if (payload) {
        state.selected = payload;
      } else {
        state.selected = null;
      }
    },

    updateFilters: (
      state,
      action: PayloadAction<Partial<PaymentActivityState["filters"]>>,
    ) => {
      const { payload } = action;
      state.filters = {
        ...state.filters,
        ...payload,
      };
    },

    resetState: () => {
      return initialState;
    },
  },
});

export const { actions } = slice;

export default {
  [name]: slice.reducer,
};
